import { useRef } from 'react';
import Particles from './Particles';
import hero from '@/images/home-hero.png';

export default function Hero() {
  const sectionRef = useRef<HTMLElement>(null);

  return (
    <section
      id="hero"
      ref={sectionRef}
      className="relative min-h-screen bg-white overflow-hidden pt-24 pb-12 md:pt-28 md:pb-16 flex items-center"
    >
      <Particles count={45} />

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-6">

          {/* LEFT — Text content */}
          <div className="flex-1 w-full max-w-xl lg:max-w-none">
            {/* Title */}
            <h1
              className="text-4xl sm:text-5xl md:text-6xl lg:text-[3.5rem] xl:text-[4rem] font-bold text-[#111] leading-[1.08] mb-6 tracking-tight animate-fade-up"
              style={{ fontFamily: 'var(--font-heading)', animationDelay: '0.4s', animationDuration: '0.9s', animationFillMode: 'forwards' }}
            >
              Haz crecer{' '}
              <span className="inline-block italic bg-gradient-to-r from-[#0CB02B] to-[#2DD44A] bg-clip-text text-transparent pr-1">
                lo que importa
              </span>
              .
            </h1>

            {/* Subtitle */}
            <p
              className="text-lg md:text-xl text-[#555] max-w-md mb-10 leading-relaxed animate-fade-up"
              style={{ animationDelay: '0.6s', animationDuration: '0.9s', animationFillMode: 'forwards' }}
            >
              Préstamos personales y empresariales con trámites rápidos, tasas competitivas y respuesta en menos de 48 horas.
            </p>

            {/* CTA row */}
            <div
              className="flex flex-wrap items-center gap-5 mb-10 animate-fade-up"
              style={{ animationDelay: '0.8s', animationDuration: '0.9s', animationFillMode: 'forwards' }}
            >
              <a
                href="#contacto"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contacto')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group relative flex items-center gap-3 px-8 py-4 bg-[#0CB02B] text-white text-base font-semibold rounded-full hover:bg-[#0A9A24] transition-all duration-400 hover:scale-[1.05] active:scale-[0.97] cursor-pointer whitespace-nowrap overflow-hidden"
              >
                <span className="absolute inset-0 bg-white/15 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></span>
                <span className="relative z-10 flex items-center gap-3">
                  Solicitar Crédito
                  <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1.5"></i>
                </span>
              </a>
            </div>

            {/* Decorative line chart */}
            <div
              className="animate-fade-in hidden md:block"
              style={{ animationDelay: '1s', animationDuration: '0.9s', animationFillMode: 'forwards' }}
            >
              <svg width="260" height="50" viewBox="0 0 260 50" fill="none" className="opacity-40">
                <path
                  d="M0 40 L50 38 L90 20 L140 28 L190 12 L230 18 L260 8"
                  stroke="#0CB02B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              </svg>
            </div>
          </div>

          {/* RIGHT — Image */}
          <div className="flex-1 w-full relative flex items-center justify-center min-h-[420px] md:min-h-[520px]">
            {/* Fondo de puntos verdes detrás de la foto */}
            <svg
              className="absolute pointer-events-none"
              style={{ width: '140%', height: '140%', left: '-18%', top: '-10%', zIndex: 0 }}
              viewBox="0 0 700 700"
            >
              <defs>
                <pattern id="hero-dots" width="22" height="22" patternUnits="userSpaceOnUse">
                  <circle cx="11" cy="11" r="4.5" fill="oklch(var(--accent-500))" />
                </pattern>
                <linearGradient id="hero-dots-fade" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="45%" stopColor="white" stopOpacity="1" />
                  <stop offset="100%" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <mask id="hero-dots-mask">
                  <circle cx="230" cy="200" r="230" fill="white" />
                  <circle cx="470" cy="370" r="170" fill="url(#hero-dots-fade)" />
                </mask>
              </defs>
              <rect width="700" height="700" fill="url(#hero-dots)" mask="url(#hero-dots-mask)" />
            </svg>
            <div className="relative w-full max-w-[520px]">
              <img
                src={hero}
                alt="Prestamos y creditos"
                className="w-full h-auto object-contain relative z-10"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}